import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0f712dec")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_3 = { key: 1 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isAlbumsRoute || _ctx.isAssetsRoute)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          class: "link-to-home",
          to: _ctx.constructLocaleAwarePath('/albums')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("home")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbsPath, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.slug
          }, [
            _hoisted_2,
            (_ctx.isNotLastIndex(index))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _ctx.generatePath(index)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.name), 1))
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}